module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('figure', [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pgvi.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_vm._v("The icon above says you’re holding a book in the Felony & Mayhem “British” category. These books are set in or around the UK, and feature the highly literate, often witty prose that fans of British mystery demand. If you enjoy this book, you may well like other “British” titles from Felony & Mayhem Press.")])]), _vm._v(" "), _c('figure', [_c('div', {
    staticClass: "image2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/comm.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("For information about British titles or to learn more about Felony & Mayhem Press, please visit us online at:")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.FelonyAndMayhem.com",
      "target": "_blank"
    }
  }, [_vm._v("www.FelonyAndMayhem.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb724420","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Fm02.vue
// module id = 75
// module chunks = 0